    
<div class="timeline-item-badge">{{'poll_results' | translate }}</div>
    
<div class="card-top" [ngClass]="{'recurring-poll': task.isRecurring}">
    <div class="pt-2 pe-2">
        <i class="fa-sharp-duotone fa-solid fa-chart-simple fa-2x ms-2 pt-1 position-relative"></i>
    </div>
    <div class="card-comment py-3 px-0" [ngClass]="{'not-recurring-poll': !task.isRecurring}">
        <p class="px-3">{{task.label}}</p>
        <mat-tab-group (selectedTabChange)="onTabChanged($event);">
            <mat-tab [label]="resultsTabLabel">
                <ng-template matTabContent>
                    @if(participationCount > 0){
                        <scale-question-result-pyramid-chart [results]="task.results" 
                                                                [chartId]="task.id"></scale-question-result-pyramid-chart>

                        <p class="px-3 pt-1 fs-6 fst-italic text-secondary text-center">
                            {{'poll_results.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'poll_results.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b>.
                        </p>
                    }@else{
                        <div class="alert alert-warning mt-2 mb-0 fs-6 fst-italic">
                            {{'poll_results.no_data'| translate}}
                        </div>
                    }
                </ng-template>
            </mat-tab>

            <mat-tab [label]="trendsTabLabel" [disabled]='!task.isRecurring'>
                <ng-template matTabContent>
                    @if(tabIndexToShow === 1){
                        <recurring-poll-result-trends [poll]="task"></recurring-poll-result-trends>
                    }
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="card-options">
        <div data-cy="report-comment" (click)="reportItem()">
            <i class="fa-regular fa-hexagon-exclamation"
                [matTooltip]="'comment-card.options.report' | translate"
                matTooltipPosition="right"></i>
        </div>
    </div>
</div>
            
<div class="card-result-comments">
    <poll-result-comments [commentResults]="task.results.values"
                          [itemType]="task.itemType"></poll-result-comments>
</div>              